import { all, call, getContext, put, takeLatest } from 'redux-saga/effects'
import { urls } from '../../routing'
import { LiteralsService, SuggestionService } from '../../services'
import { addSuggestionSuccessfulAction, setIsLoadingSuggestionsAction, setNotificationAction } from '../actions'
import { SuggestionsTypeKeys } from '../types'

function* addSuggestionAsync(action: any): any {
  const routerHistory = yield getContext('routerHistory')
  try {
    yield put(setIsLoadingSuggestionsAction(true))
    yield call(SuggestionService.addSuggestion, action.payload)
    yield call(routerHistory.push, urls.configuration.complaintsAndSuggestionsDone)
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  } finally {
    yield put(setIsLoadingSuggestionsAction(false))
  }
  yield put(addSuggestionSuccessfulAction())
}

function* watchAddSuggestionAsync() {
  yield takeLatest(SuggestionsTypeKeys.ADD_SUGGESTION, addSuggestionAsync)
}

export default function* rootSaga() {
  yield all([watchAddSuggestionAsync()])
}
